module.exports = __webpack_public_path__ + "static/media/dev-3.49f73372.png";